import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { Breakpoints } from 'src/Configuration/breakpoints'
import { WIDGET_HEIGHT } from './widgets/base-card/const'
import DashboardWidgetContainer from './ResponsiveContainer'

/*
 * The most common widget amount would be:
 * 1. DPP/Forecast
 * 2. Battery
 * 3. at least 1 Wallbox (empty) widget
 * Adding +1 for mobile because even number of widgets looks better in a 2-column grid system.
 */
const DEFAULT_WIDGETS_AMOUNT_DESKTOP = 3
const DEFAULT_WIDGETS_AMOUNT_MOBILE = 4

/*
 * A skeleton for widgets that are loading.
 */
const WidgetsSkeleton: React.FC<{ amountOfWidgets?: number | null }> = ({ amountOfWidgets }) => {
  const theme = useTheme()
  const isMobileTablet = useMediaQuery(theme.breakpoints.down(Breakpoints.Desktop))

  const DEFAULT_WIDGETS_AMOUNT = isMobileTablet ? DEFAULT_WIDGETS_AMOUNT_MOBILE : DEFAULT_WIDGETS_AMOUNT_DESKTOP

  return (
    <DashboardWidgetContainer>
      {[...Array(amountOfWidgets ?? DEFAULT_WIDGETS_AMOUNT)].map((_, index) => (
        <SkeletonWidget key={`skeleton-${index}`} />
      ))}
    </DashboardWidgetContainer>
  )
}

export default WidgetsSkeleton

const SkeletonWidget: React.FC = () => {
  const theme = useTheme()
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        height: '100%',
        width: '100%',
        borderRadius: 1,
        padding: '6px',
        minHeight: WIDGET_HEIGHT,
        maxHeight: WIDGET_HEIGHT,
        minWidth: isUpSm ? 200 : 150,
        flex: '1 1 0',
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
        <Skeleton variant="text" width="70%" sx={{ borderRadius: 1 }} />
        <Skeleton variant="circular" width={20} height={20} sx={{ borderRadius: 1 }} />
      </Box>

      <Skeleton variant="rectangular" sx={{ marginTop: 'auto', borderRadius: 1, minHeight: '70px', height: '70%', width: '100%' }} />
    </Box>
  )
}
